import {
  type CaseOut,
  type CorrectionOut,
  type DocumentOut,
  getCaseOptions,
  getImportStatusOptions,
  type ImportStatus,
  listCorrectionsOptions,
  listDocumentsOptions,
} from "@platform/api/golden";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useGoldenClient } from "../api/GoldenClientProvider";
import { BACKGROUND_POLL_MS } from "../api/polling";

export const useCase = (caseId: number): UseQueryResult<CaseOut> => {
  const client = useGoldenClient();
  return useQuery(getCaseOptions({ client, path: { case_id: caseId } }));
};

/** Whether the case's document import is running, asked again until it is not. */
export const useImportStatus = (
  caseId: number,
): UseQueryResult<ImportStatus> => {
  const client = useGoldenClient();
  return useQuery({
    ...getImportStatusOptions({ client, path: { case_id: caseId } }),
    refetchInterval: (query) =>
      query.state.data?.running ? BACKGROUND_POLL_MS : false,
  });
};

export const useCaseDocuments = (
  caseId: number,
): UseQueryResult<DocumentOut[]> => {
  const client = useGoldenClient();
  return useQuery(listDocumentsOptions({ client, path: { case_id: caseId } }));
};

export const useCaseCorrections = (
  caseId: number,
): UseQueryResult<CorrectionOut[]> => {
  const client = useGoldenClient();
  return useQuery(
    listCorrectionsOptions({ client, path: { case_id: caseId } }),
  );
};
